<!-- eslint-disable prettier/prettier -->
<mat-card appearance="outlined">
	<mat-card-content>

		@if (soloLectura) {

		<!-- ─── Vista resumen ──────────────────────────────────────────────── -->
		@if (contacts().length === 0) {
		<p class="contacts-empty-text">Sin completar</p>
		} @else {
		<div class="contacts-read-grid">
			@for (c of contacts(); track c.tipoContacto) {
			<div class="info-field">
				<span class="info-field__label">{{ getTipoContactoDescription(c.tipoContacto) }}</span>
				<span class="info-field__value">
					{{ c.valor }}
					@if (c.tipoContacto === 'correoElectronico') {
					<span
						class="email-badge"
						[class.valid]="c.emailValidado === '1'"
						[class.pending]="c.emailValidado === '2'"
						[class.invalid]="c.emailValidado === '0'"
					>
						{{ c.emailValidado === '1' ? 'Validado' : c.emailValidado === '2' ? 'Pendiente' : 'No validado' }}
					</span>
					}
				</span>
			</div>
			}
		</div>
		}

		} @else {

		<!-- ─── Vista edición ──────────────────────────────────────────────── -->

		<!-- Lista de contactos -->
		@if (contacts().length > 0) {
		<div class="contacts-list">
			@for (c of contacts(); track c.tipoContacto; let i = $index) {
			<div class="contact-item" [class.contact-item--editing]="contactoEditIndex() === i">
				<div class="contact-item__content">
					<span class="info-field__label">{{ getTipoContactoDescription(c.tipoContacto) }}</span>
					<span class="info-field__value">
						{{ c.valor }}
						@if (c.tipoContacto === 'correoElectronico') {
						<span
							class="email-badge"
							[class.valid]="c.emailValidado === '1'"
							[class.pending]="c.emailValidado === '2'"
							[class.invalid]="c.emailValidado === '0'"
						>
							{{ c.emailValidado === '1' ? 'Validado' : c.emailValidado === '2' ? 'Pendiente' : 'No validado' }}
						</span>
						}
					</span>
				</div>
				<div class="contact-item__actions">
					<button mat-icon-button (click)="editarContacto(c, i)" matTooltip="Editar">
						<lucide-icon name="pencil" [size]="16" [strokeWidth]="1.5" color="#131416"></lucide-icon>
					</button>
					<button mat-icon-button (click)="eliminarContacto(i)" matTooltip="Eliminar">
						<lucide-icon name="trash-2" [size]="16" [strokeWidth]="1.5" color="#131416"></lucide-icon>
					</button>
				</div>
			</div>
			}
		</div>
		}

		<!-- Formulario inline -->
		@if (modoEdicionContacto() || mostrarFormAgregar()) {
		<section class="contacts-form" [class.contacts-form--editing]="modoEdicionContacto()">
			<h3 class="contacts-form__title">
				{{ modoEdicionContacto() ? 'Editar contacto' : 'Agregar contacto' }}
			</h3>

			<form [formGroup]="contactForm" class="contacts-form__grid">
				<mat-form-field appearance="outline">
					<mat-label>Tipo de contacto</mat-label>
					<mat-select formControlName="tipoContacto">
						@for (t of tiposContactoFiltered(); track t.id) {
						<mat-option [value]="t.id">{{ t.description }}</mat-option>
						}
					</mat-select>
				</mat-form-field>

				<mat-form-field appearance="outline">
					<mat-label>{{ labelValorContacto() }}</mat-label>
					<input
						matInput
						[type]="getInputType(contactForm.get('tipoContacto')?.value)"
						[placeholder]="placeholderValorContacto()"
						formControlName="valorContacto"
					/>
					@if (contactForm.get('tipoContacto')?.value === 'correoElectronico' && modoEdicionContacto()) {
					<mat-hint>El email quedará pendiente de validación</mat-hint>
					}
				</mat-form-field>
			</form>

			<div class="contacts-actions">
				@if (modoEdicionContacto()) {
				<button mat-raised-button class="btn-primary" (click)="guardarEdicionContacto()">
					<lucide-icon name="save" [size]="16" [strokeWidth]="1.5" color="#ffffff"></lucide-icon>
					Modificar
				</button>
				} @else {
				<button mat-raised-button class="btn-primary" (click)="agregarNuevoContacto()">
					<lucide-icon name="plus" [size]="16" [strokeWidth]="1.5" color="#ffffff"></lucide-icon>
					Confirmar
				</button>
				}
				<button mat-stroked-button class="btn-cancel" (click)="cancelarEdicion()">
					Cancelar
				</button>
			</div>
		</section>
		} @else {
		<!-- Botón para abrir formulario de agregar -->
		<button mat-stroked-button class="btn-add" (click)="mostrarFormAgregar.set(true)">
			<span class="btn-icon-label">
				<lucide-icon name="plus" [size]="16" [strokeWidth]="1.5" color="#5f1f7b"></lucide-icon>
				Agregar contacto
			</span>
		</button>
		}

		}

	</mat-card-content>
</mat-card>
